<template>
    <div>
      <div class="d-flex justify-content-between">
        <h1 class="page-header">{{ $t('receipt.pageTitle') }}</h1>
        <ts-breadcrumb
          :items="[
            { text: $t('toHomePage'), href: '/' },
            {
              text: $t('receipt.pageTitle'),
              active: true
            }
          ]"
        />
      </div>
      <ts-card>
        <ts-card-wrapper>
          <div class="d-flex justify-content-between">
            <div class="d-flex">
              <ts-button
                outline
                color="info"
                @click="$router.push({ name: 'receipt-create' })"
                >{{ $t('add_new') }}</ts-button
              >
              <a-range-picker
                  style="width: 280px; margin-left: 12px;"
                  format="DD-MM-YYYY"
                  :defaultValue="rangeDate"
                  :defaultPickerValue="rangeDate"
                  @change="dateRangeChange"
                >
                  <template slot="renderExtraFooter"></template>
              </a-range-picker>
            </div>
            <div class="d-flex">
              <ts-input
                v-model="search"
                :placeholder="$t('search')"
                style="width: 250px"
                class="inline-block"
              />
              <ts-button
                outline
                class="ml-2"
                v-tooltip="$t('invoice.filter')"
                @click.prevent="visible = true"
              >
                <i class="fa fa-filter"></i>
              </ts-button>
            </div>
          </div>
          <a-drawer
            :title="$t('filter')"
            placement="right"
            :closable="false"
            :visible="visible"
            @close="() => (visible = false)"
            :zIndex="1020"
            width="300px"
          >
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <a-select
                    style="width: 257px"
                    v-model="model.branch_id"
                    :options="branchs"
                    showSearch
                    mode="multiple"
                    :filterOption="
                      (input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                    "
                    :maxTagCount="1"
                    :maxTagTextLength="17"
                    :placeholder="$t('all')"
                  >
                  </a-select>
                </div>
              </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                  <ts-checkbox v-model="model.is_deleted"
                    >Voided</ts-checkbox
                  >
                </div>
            </div>
          </a-drawer>
        </ts-card-wrapper>
        <div class="overflow-auto">
          <ts-table
            :columns="columns"
            :records="resources"
            :loading="loading"
            :rowGroup="{
              field: 'payment_date'
            }"
          >
            <template v-slot="{ record }">
              <td class="ts-whitespace-no-wrap">
                {{ record.rcp_number }}
              </td>
              <td class="ts-whitespace-no-wrap">
                {{ record.invoice ? record.invoice.inv_number : null }}
              </td>
              <td class="ts-whitespace-no-wrap">
                {{ record.invoice ? record.invoice.student.card_number : null }}
              </td>
              <td class="ts-whitespace-no-wrap">
                {{ record.invoice ? record.invoice.student.full_name_en : null }}
              </td>
              <td class="ts-whitespace-no-wrap text-right">
                $ {{ formatNumber(record.inv_amount) }}
              </td>
              <td class="ts-whitespace-no-wrap text-right">
                $ {{ formatNumber(record.amount_paid_usd) }}
              </td>
              <td class="ts-whitespace-no-wrap text-right">
                ៛ {{ formatNumber(record.amount_paid_khr) }}
              </td>
              <td class="ts-whitespace-no-wrap text-right">
                $ {{ formatNumber(record.amount_due) }}
              </td>
              <td class="text-center">
                <a
                  href="#"
                  class="text-primary"
                  v-tooltip="$t('receipt.view')"
                  @click.prevent="view(record)"
                >
                  <i class="fas fa-eye"></i>
                </a>
                <a
                  href="#"
                  class="text-red ml-2"
                  v-tooltip="$t('pdf')"
                  @click.prevent="printPDF(record)"
                >
                  <i class="fas fa-file-pdf"></i>
                </a>
              </td>
            </template>
          </ts-table>
        </div>
        <div class="d-flex justify-content-end p-15">
          <ts-pagination
            v-model="pagination"
            @navigate="fetchData"
          ></ts-pagination>
        </div>
        <a-modal
          v-model="viewModal"
          :title="$t('receipt.view')"
          @cancel="() => (viewModal = false)"
          width="400px"
          :maskClosable="false"
          :footer="null"
          :zIndex="1020"
        >
          <view-component :resource="viewResource" />
        </a-modal>
        <a-modal
          v-model="pdfModal"
          :title="$t('pdf')"
          @cancel="() => (pdfModal = false)"
          width="50%"
          :maskClosable="false"
          :footer="null"
          :zIndex="1020"
        >
          <preview-pdf-component :src="src" :waiting="waiting" />
        </a-modal>
      </ts-card>
    </div>
  </template>
  <script>

  class Pagination {
    constructor(paging = {}) {
      this.currentPage = paging.currentPage ? parseInt(paging.currentPage) : 1
      this.lastPage = paging.lastPage ? parseInt(paging.lastPage) : 0
      this.perPage = paging.perPage ? parseInt(paging.perPage) : 15
      this.total = paging.total ? parseInt(paging.total) : 0
      this.from = this.perPage * (this.currentPage - 1) + 1
      this.to = this.perPage * this.currentPage
    }
  }

  import { debounce } from 'lodash'
  import moment from 'moment'
  import { PreviewPdfComponent, ViewComponent } from './components'
  
  export default {
    name: 'receipt',
    components: {
      ViewComponent,
      PreviewPdfComponent
    },
    data () {
      return {
        visible: false,
        viewModal: false,
        pdfModal: false,
        waiting: false,
        src: null,
        search: '',
        loading: false,
        branchs: [],
        resources: [],
        rangeDate: [moment(), moment()],
        pagination: new Pagination(),
        viewResource: {},
        model: {
          is_deleted: false,
          branch_id: undefined
        }
      }
    },
    created () {
      this.fetchData({
        page: 1, 
        perPage: 15,
        is_deleted: false,
        date_from: moment().format('DD-MM-YYYY'),
        date_to: moment().format('DD-MM-YYYY')
      })
      this.getBranch()
    },
    computed: {
      columns () {
        return [
          { name: this.$t('receipt.receiptNumber') },
          { name: this.$t('receipt.invoiceNumber') },
          { name: this.$t('receipt.cardNumber') },
          { name: this.$t('receipt.student') },
          { name: this.$t('receipt.totalAmount'), style: 'text-align:right' },
          { name: this.$t('receipt.paidAmountUsd'), style: 'text-align:right' },
          { name: this.$t('receipt.paidAmountKhr'), style: 'text-align:right' },
          { name: this.$t('receipt.amountDue'), style: 'text-align:right' },
          { name: this.$t('actions'), style: 'text-align:center; width:2%' }
        ]
      },
      formatNumber: () => number => {
        if (number === undefined) return 0
        return new Intl.NumberFormat('en-IN', {
          maximumFractionDigits: 3
        }).format(number)
      }
    },
    methods: {
      fetchData (attributes) {
        this.loading = true
        this.$store
          .dispatch(
            'receiptModule/onFetch',
            Object.assign({}, attributes)
          )
          .then(response => {
            this.resources = response.data.data
            this.RECEIVE_RESOURCES(response.data)
            this.loading = false
          })
          .catch(error => {
            this.loading = false
            this.$toasted.error(error.response.data.message)
          })
      },
      RECEIVE_RESOURCES(records) {
        const { data, ...meta } = records
        this.resources = data
        this.$nextTick(() => {
          this.pagination.currentPage = meta.meta.current_page
          this.pagination.lastPage = meta.meta.last_page
          this.pagination.perPage = meta.meta.per_page
          this.pagination.total = meta.meta.total
          this.pagination.from = meta.meta.from
          this.pagination.to = meta.meta.to
        })
      },
      getBranch () {
        this.$store
          .dispatch('user/getBranch', {
            filter: {
              user_branches: true
            }
          })
          .then(response => {
            this.branchs = response.data.map(el => ({
              value: el.branch_id,
              label: el.branch_name_en
            }))
          })
      },
      dateRangeChange (dateRange) {
        this.$store.commit(
          'receiptModule/SET_DATE_FROM',
          dateRange[0].format('DD-MM-YYYY')
        )
        this.$store.commit(
          'receiptModule/SET_DATE_TO',
          dateRange[1].format('DD-MM-YYYY')
        )
        this.fetchData({
          search: this.search,
          branch_id: this.model.branch_id,
          is_deleted: this.model.is_deleted
        })
      },
      view (record) {
        this.viewModal = true
        this.viewResource = record
      },
      printPDF (record) {
        this.pdfModal = true
        this.waiting = true
        this.$store
          .dispatch('receiptModule/onPreviewPdf', {id: record.rcp_id})
          .then(response => {
            this.src = response.data.url
          })
          .catch(error => {
            this.$toasted.error(error.response.data.message)
          })
          .finally(() => {
            this.waiting = false
          })
      }
    },
    watch: {
      search: debounce(function (search) {
        this.fetchData({ 
          search, branch_id: this.model.branch_id, is_deleted: this.model.is_deleted
        })
      }, 500),
      'model.branch_id': debounce(function (value) {
        this.fetchData({ branch_id: value, search: this.search, is_deleted: this.model.is_deleted })
      }, 500),
      'model.is_deleted': debounce(function (value) {
        this.fetchData({ 
          is_deleted: value,
          search: this.search, 
          branch_id: this.model.branch_id
        })
      }, 500)
    }
  }
  </script>
  